module.exports = __webpack_public_path__ + "static/media/disfraz-bebe.51fc6e33.jpg";